module.exports = __webpack_public_path__ + "static/media/facebook-login.29318c7a.png";